export enum TvFeatureTypes {
	tvToGo='tv to go',
	hd='hd',
}
